<script setup lang="ts">
defineProps<{ href: string }>()
</script>

<template>
  <div>
    <a
      data-testid="navigation-menu"
      external
      class="flex items-center justify-between rounded-lg font-montserrat text-sm font-normal hover:bg-s-200 xl:text-base xl:leading-5"
      :href="href"
    >
      <span class="max-w-[200px]">
        <slot />
      </span>
    </a>
  </div>
</template>
